const MCALLEN_API = "https://dashboard.elitepokerlounge.com/api";
const BROWNSVILLE_API = "https://dashboard.brownsville.elitepokerlounge.com/api";

export function getApiBaseUrl() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();
    if (host.includes("brownsville")) return BROWNSVILLE_API;
    if (host.includes("elitepokerlounge") || host.includes("mcallen")) {
      return MCALLEN_API;
    }
  }
  return process.env.REACT_APP_API_URL || MCALLEN_API;
}

export { MCALLEN_API, BROWNSVILLE_API };
